import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import { clearAuthErrors, fetchGiftCards, disableGiftCard, clearGiftCardsErrors } from '../actions';
import ShowGiftCards from '../components/giftCards/ShowGiftCards';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  giftcards: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class GiftCardsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    this.props.dispatch(clearGiftCardsErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const { query, router, giftcards: search } = this.props;
    if (search && search.length > 0) {
      query.search = search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/giftcards', query });
    } else {
      this.props.dispatch(fetchGiftCards(query));
    }
  }
  onGiftCardDisable(data) {
    var new_giftcard =  {
      balance: data.balance,
      disabled: data.disabled
    }
    this.props.dispatch(disableGiftCard(data.id, new_giftcard));
    this.props.dispatch(fetchGiftCards(this.props.query));
  }
  handleSearchChange(e) {
    const { giftcards, query, router } = this.props;
    const nextName = e.target.value;
    giftcards.search = nextName;
    this.setState({
      giftcards,
    });
    if (nextName.length > 0) {
      query.search = nextName;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/giftcards', query });
    this.props.dispatch(fetchGiftCards(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchGiftCards(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    // const showAdmin = (['0', '1', '2'].indexOf(localStorage.getItem('scope')) < 2 ) ? 'inline' : 'none';
    return (
      <div className="giftcard component" style={authPage}>
        <h2>Gift Cards</h2>
        <div className="content">
         <div className="action-buttons">
         <Link to={'/giftcards/new'}>
              <RaisedButton
                label="Add New Gift Card"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Gift Card Code"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.giftcards.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.giftcards.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowGiftCards
            giftcards={this.props.giftcards}
            onGiftCardDisable={data => this.onGiftCardDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.giftcards.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

GiftCardsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

GiftCardsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    giftcards: state.giftCards,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(GiftCardsPage));



// WEBPACK FOOTER //
// ./src/containers/GiftCardsPage.js